const styles = theme => {
    return ({
        paper: theme.mixins.gutters({
            paddingTop: 16,
            paddingBottom: 16,
            marginBottom: 16,
            boxShadow: 'none',
            marginTop: 32,
        }),
        update: {
            marginTop: 30,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: '#fd5622',
            }
        },
        error: {
            background: theme.palette.secondary.main,
            color: theme.palette.common.white,
            textAlign: 'center'
        }
    })
}

export default styles
